import { useEffect, useState } from 'react';
import { API } from '../service/ProductsService';
import { basket } from '../utils/basketStore';

// נפתח כשנכנסים מקישור הזמנה ?joinList=<code> (MainPage, אחרי התחברות): מי הזמין, מה יקרה לרשימה שלי, והצטרפות.
// onJoined — MainPage עובר לטאב רשימת הקניות.

const s = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '10vh 12px', zIndex: 120 },
  dialog:  { width: '100%', maxWidth: 460, background: '#fff', borderRadius: 14, padding: 22, boxShadow: '0 16px 48px rgba(0,0,0,.25)', textAlign: 'center' },
  icon:    { fontSize: 40, marginBottom: 6 },
  title:   { margin: '0 0 8px', fontSize: 20, fontWeight: 700 },
  text:    { margin: '0 0 10px', color: '#59636e', fontSize: 15, lineHeight: 1.6 },
  note:    { margin: '0 0 16px', padding: '8px 12px', background: '#eef4ff', color: '#1a3f9c', borderRadius: 10, fontSize: 14 },
  actions: { display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap', marginTop: 14 },
  primary: { padding: '11px 22px', fontSize: 16, fontWeight: 700, border: 'none', borderRadius: 10, background: '#1a3f9c', color: '#fff' },
  secondary:{ padding: '10px 18px', fontSize: 15, fontWeight: 600, border: '1px solid #d0d7de', borderRadius: 10, background: '#fff', color: '#1f2328' },
  error:   { background: '#fff1f0', border: '1px solid #ffccc7', color: '#a8071a', padding: '10px 14px', borderRadius: 10, marginBottom: 8 },
};

const JoinListDialog = ({ code, onClose, onJoined }) => {
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    let alive = true;
    API.getShoppingListInvite(code)
      .then((resp) => {
        if (!alive) return;
        const status = resp?.[0]?.[0];
        if (status?.code === 0) setInvite(resp[1]?.[0]);
        else if (status?.code !== 90) setError(status?.msg || 'הקישור לא תקין');
      })
      .catch(() => alive && setError('אין חיבור לשרת'));
    return () => { alive = false; };
  }, [code]);

  const join = async () => {
    setJoining(true);
    const r = await basket.join(code);
    setJoining(false);
    if (r.ok) onJoined(); else setError(r.msg || 'לא הצלחנו להצטרף לרשימה');
  };

  return (
    <div style={s.overlay} onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={s.dialog} role="dialog" aria-modal="true" aria-labelledby="join-title">
        <div style={s.icon} aria-hidden="true">🛒</div>
        {error && <div style={s.error} role="alert">{error}</div>}
        {!invite && !error && <p style={s.text}>טוען את ההזמנה…</p>}

        {invite && invite.alreadyMember && (
          <>
            <h2 id="join-title" style={s.title}>כבר ברשימה המשותפת</h2>
            <p style={s.text}>את/ה כבר חלק מרשימת הקניות של {invite.ownerName}.</p>
            <div style={s.actions}><button type="button" style={s.primary} onClick={onJoined}>לרשימת הקניות</button></div>
          </>
        )}

        {invite && !invite.alreadyMember && (
          <>
            <h2 id="join-title" style={s.title}>{invite.ownerName} הזמין/ה אותך לרשימת קניות משותפת</h2>
            <p style={s.text}>
              ברשימה {invite.itemCount} מוצרים{invite.memberCount > 1 ? ` ו-${invite.memberCount} משתתפים` : ''}.
              אחרי ההצטרפות, כל מה שאחד מוסיף מופיע אצל כולם.
            </p>
            {invite.myItemCount > 0 && (
              <p style={s.note}>{invite.myItemCount} המוצרים שכבר ברשימה שלך יתווספו לרשימה המשותפת</p>
            )}
            <div style={s.actions}>
              <button type="button" style={s.primary} onClick={join} disabled={joining}>{joining ? 'מצטרף…' : 'הצטרפות לרשימה'}</button>
              <button type="button" style={s.secondary} onClick={onClose} disabled={joining}>לא עכשיו</button>
            </div>
          </>
        )}

        {error && <div style={s.actions}><button type="button" style={s.secondary} onClick={onClose}>סגירה</button></div>}
      </div>
    </div>
  );
};

export default JoinListDialog;
